"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _chunkOSLA7LY6js = require('./chunk-OSLA7LY6.js');var _chunkPOE2IUJUjs = require('./chunk-POE2IUJU.js');var _chunkMQ5AGG7Cjs = require('./chunk-MQ5AGG7C.js');var _chunkQGSV7IABjs = require('./chunk-QGSV7IAB.js');var _chunkM3G47PXCjs = require('./chunk-M3G47PXC.js');var _chunkBDF663TKjs = require('./chunk-BDF663TK.js');var _chunkOL2KRAIPjs = require('./chunk-OL2KRAIP.js');var _styled = require('@emotion/styled'); var _styled2 = _interopRequireDefault(_styled);var _react = require('react'); var _react2 = _interopRequireDefault(_react);var _jsxruntime = require('react/jsx-runtime');var B=_styled2.default.a`
  display: flex;
  flex-flow: column;
  cursor: pointer;
  width: fit-content;
  max-width: ${e=>e.theme.measurements.spacing(136)};
`,_=_styled2.default.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: ${e=>e.theme.measurements.spacing(1.5)};
`,H=_styled2.default.div`
  width: ${e=>e.theme.measurements.spacing(104)};
  height: ${e=>e.theme.measurements.spacing(1)};
  border-radius: ${e=>e.theme.measurements.spacing(10)};
  background: ${e=>e.theme.palette.DIVIDER};
`,O=_styled2.default.div`
  position: relative;
  display: block;
  min-height: fit-content;
  min-width: fit-content;
  height: ${e=>e.theme.measurements.spacing(78)};
  img {
    width: 100%;
    max-width: ${e=>e.theme.measurements.spacing(136)};
    height: ${e=>e.theme.measurements.spacing(78)};
    border-radius: ${e=>e.theme.measurements.shape(2)};
  }
`,V=_styled2.default.div`
  display: flex;
  flex-flow: column;
  position: absolute;
  bottom: ${e=>e.theme.measurements.spacing(6)};
  gap: ${e=>e.theme.measurements.spacing(4)};
  left: ${e=>e.theme.measurements.spacing(6)};
  right: ${e=>e.theme.measurements.spacing(6)};
`,j=_styled2.default.div`
  display: flex;
  flex-flow: column;
  position: absolute;
  top: ${e=>e.theme.measurements.spacing(6)};
  gap: ${e=>e.theme.measurements.spacing(4)};
  left: ${e=>e.theme.measurements.spacing(6)};
  right: ${e=>e.theme.measurements.spacing(6)};
`,Y=_styled2.default.div`
  display: flex;
  align-items: flex-end;
`,F=_styled2.default.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${e=>e.theme.measurements.spacing(4)};
  justify-content: flex-start;
  flex: 1;
`,W=_styled2.default.div`
  display: flex;
  gap: ${e=>e.theme.measurements.spacing(4)};
  justify-content: flex-end;
`,q=_styled2.default.call(void 0, _chunkPOE2IUJUjs.a)`
  text-transform: uppercase;
  padding: ${e=>e.theme.measurements.spacing(2)}
    ${e=>e.theme.measurements.spacing(3)};
`,G=_styled2.default.call(void 0, _chunkM3G47PXCjs.b)`
  background-color: ${e=>e.theme.palette.BASE_ONE};
  border-radius: ${e=>e.theme.measurements.spacing(4)};
`,J=_styled2.default.call(void 0, _chunkPOE2IUJUjs.a)`
  border: none;
  display: ${e=>e.$variant==="locked"?"none":"flex"};
  gap: ${e=>e.theme.measurements.spacing(2)};
  font-weight: 600;
`,K=_styled2.default.call(void 0, _chunkPOE2IUJUjs.a)`
  border: none;
  display: 'flex';
  flex-wrap: wrap;
  gap: ${e=>e.theme.measurements.spacing(1)};
  font-weight: 600;
  height: 22px;
`,Q=_styled2.default.div`
  display: flex;
  justify-content: flex-end;
`,U=_styled2.default.div`
  display: flex;
  flex-flow: column;
  margin-top: ${e=>e.theme.measurements.spacing(6)};
  gap: ${e=>e.theme.measurements.spacing(3)};
`,X=_styled2.default.call(void 0, _chunkMQ5AGG7Cjs.a)`
  line-height: ${e=>e.theme.measurements.spacing(12)};
`,Z=_styled2.default.div`
  display: flex;
  flex-direction: row;
  gap: ${e=>e.theme.measurements.spacing(4)};
  align-items: center;
`,ee=_styled2.default.call(void 0, _chunkMQ5AGG7Cjs.a)`
  color: ${e=>e.$topicColor||e.theme.palette.VIOLET};
  font-size: ${e=>e.theme.measurements.spacing(6)};
  font-weight: 700;
  line-height: ${e=>e.theme.measurements.spacing(6)};
  text-transform: uppercase;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`,x=_styled2.default.div`
  font-size: ${e=>e.theme.measurements.spacing(7)};
  line-height: ${e=>e.theme.measurements.spacing(10)};
  color: ${e=>e.theme.palette.SECONDARY};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`,te=_styled2.default.call(void 0, x)`
  a {
    color: ${e=>e.theme.palette.SECONDARY};
  }
`,ne=_styled2.default.call(void 0, x)``,ae=_styled2.default.call(void 0, _chunkPOE2IUJUjs.a)`
  white-space: nowrap;
`,se=_react2.default.forwardRef((e,y)=>{let{title:p,langLabel:I="EN",variant:s,viewCount:d=0,progress:l=0,topicName:k,topicColor:E,educatorName:o,detailsLine:h,onClick:g,href:M,thumbnail:C,educatorLink:f="",className:R,as:N="a",lessonCompletedCount:$=0,lessonTotalCount:r=0}=e,v=_chunkOL2KRAIPjs.b.call(void 0, ),A=_react.useMemo.call(void 0, ()=>s==="continue_watching"&&l,[s,l]),D=m=>{m.preventDefault(),g&&g(m)},P=m=>{m.stopPropagation()};return _jsxruntime.jsxs.call(void 0, B,{ref:y,className:`${R||""} aquilla-coursecard coursecard`,onClick:D,href:M,title:p,rel:"noopener noreferrer",as:N,children:[_jsxruntime.jsx.call(void 0, _,{children:_jsxruntime.jsx.call(void 0, H,{})}),_jsxruntime.jsxs.call(void 0, O,{children:[C?_jsxruntime.jsx.call(void 0, C,{}):"",_jsxruntime.jsxs.call(void 0, V,{"aria-label":"infosection",children:[_jsxruntime.jsxs.call(void 0, Y,{"aria-label":"infocontainer",children:[_jsxruntime.jsxs.call(void 0, F,{"aria-label":"left",children:[s==="live"?_jsxruntime.jsx.call(void 0, q,{variant:"solid",color:v.RED,size:"small",children:"Live"}):"",d?_jsxruntime.jsxs.call(void 0, J,{$variant:s,size:"small",variant:"default",children:[_jsxruntime.jsx.call(void 0, _chunkBDF663TKjs.b,{height:16,width:16})," ",d]}):"",r?_jsxruntime.jsx.call(void 0, K,{size:"small",variant:"default",children:$?_jsxruntime.jsxs.call(void 0, "span",{children:[_jsxruntime.jsx.call(void 0, _chunkQGSV7IABjs.b,{height:7,width:10})," Lesson"," ",$,"/",r]}):_jsxruntime.jsxs.call(void 0, "span",{children:[_jsxruntime.jsx.call(void 0, _chunkQGSV7IABjs.b,{height:7,width:10})," ",r," ",r===1?"lesson":"lessons"]})}):""]}),_jsxruntime.jsx.call(void 0, Q,{})]}),A?_jsxruntime.jsx.call(void 0, _chunkOSLA7LY6js.a,{progress:l}):""]}),_jsxruntime.jsx.call(void 0, j,{children:_jsxruntime.jsx.call(void 0, W,{"aria-label":"right",children:s==="locked"?_jsxruntime.jsx.call(void 0, G,{color:v.PRIMARY,height:32,width:32,children:"Live"}):""})})]}),_jsxruntime.jsxs.call(void 0, U,{children:[_jsxruntime.jsxs.call(void 0, Z,{children:[_jsxruntime.jsx.call(void 0, ae,{variant:"default",size:"small",children:I}),_jsxruntime.jsx.call(void 0, ee,{as:"div",variant:"h1",$topicColor:E,children:k})]}),_jsxruntime.jsx.call(void 0, X,{variant:"h5",children:p}),o?_jsxruntime.jsx.call(void 0, te,{title:o,children:f?_jsxruntime.jsx.call(void 0, "a",{href:f||"",title:o,onClick:P,children:o}):o}):null,_jsxruntime.jsx.call(void 0, ne,{title:h,children:h})]})]})}),he= exports.a =se;exports.a = he;
